<script setup lang="ts">
import { CollapsibleTrigger } from 'radix-vue'

import Button from '../Button/Button.vue'

interface Props {
  isOpen: boolean
}

defineProps<Props>()
</script>

<template>
  <CollapsibleTrigger>
    <Button
      class="cursor-pointer"
      :icon="isOpen ? 'caret-up' : 'caret-down'"
      variant="trigger"
      size="sm"
      iconSize="lg"
      square
    />
  </CollapsibleTrigger>
</template>
